import React from "react";

import { StatusBadgeProps } from "./statusBadgeProps";

export const OfferedStatusBadge = (props: StatusBadgeProps) => {
    const { width, height = "18", viewBox = "0 0 49 18", ...rest } = props;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox={viewBox}
            {...rest}
            data-cy="offeredBadge"
        >
            <g
                fill="none"
                fillRule="evenodd"
                stroke="none"
                strokeWidth="1"
                transform="translate(-957 -10295) translate(957 10295)"
            >
                <rect
                    width="49"
                    height="18"
                    x="0"
                    y="0"
                    fill="#6EEDB8"
                    rx="1.966"
                ></rect>
                <path
                    fill="#210071"
                    fillRule="nonzero"
                    d="M9.927 13.373C7.238 13.373 6 11.403 6 9.186 6 6.97 7.238 5 9.927 5c2.69 0 3.928 1.97 3.928 4.186 0 2.218-1.238 4.187-3.928 4.187zm0-1.296c1.745 0 2.384-1.353 2.384-2.89 0-1.532-.639-2.886-2.384-2.886-1.744 0-2.384 1.354-2.384 2.885 0 1.538.64 2.891 2.384 2.891zm5.448 1.18V5.122h5.77v1.342h-4.307v2.056h3.8V9.86h-3.8v3.398h-1.463zm7.112 0V5.122h5.77v1.342H23.95v2.056h3.8V9.86h-3.8v3.398h-1.463zm7.112 0V5.122h5.413v1.342h-3.95v2.056h3.68V9.86h-3.68v2.016h3.95v1.382h-5.413zm7.17 0V5.122h2.63c1.521 0 2.817.87 2.817 2.396 0 1.025-.668 1.802-1.59 2.119l2.264 3.622h-1.676L39.21 9.78h-.98v3.478h-1.462zm1.473-4.67h1.29c.778-.034 1.238-.437 1.238-1.047 0-.674-.524-1.112-1.359-1.112h-1.169v2.16z"
                ></path>
            </g>
        </svg>
    );
};
